module.exports = __webpack_public_path__ + "homelike-logo.png?1cfd785441d53a1e0fc3d37589314c8f";